import { useSearchParams } from 'react-router-dom';
import { publicCatalogApi } from '@/features/publicsite/catalog/api/publicCatalogApi';
import { CatalogCard } from '@/features/publicsite/catalog/CatalogCard';
import { CatalogSection } from '@/features/publicsite/catalog/CatalogSection';
import { ListingFilterPanel } from '@/features/publicsite/ListingFilterPanel';
import { providerPath } from '@/features/publicsite/providerPath';
import type { AdvisoryService } from '@/features/publicsite/types/services/AdvisoryService';
import { usePublicList } from '@/features/publicsite/usePublicList';
import { serviceTypeLabel } from '@/features/common/serviceType';
import { publicCatalog } from '@/i18n/dictionaries/publicCatalog';
import { useTranslation } from '@/i18n/useTranslation';

export function ServicesPage() {
  const { t, language } = useTranslation(publicCatalog);
  const [params, setParams] = useSearchParams();
  const query = params.get('q') ?? '';
  const services = usePublicList<AdvisoryService>(publicCatalogApi.servicesUrl(query));

  return (
    <CatalogSection
      eyebrow={t('eyebrowCatalog')}
      heading={t('servicesHeading')}
      lead={t('servicesLead')}
      items={services}
      renderCard={(s, i) => (
        <CatalogCard
          key={`${s.providerName}-${i}`}
          to={providerPath({ slug: s.providerSlug })}
          badge={serviceTypeLabel(s.type, language)}
          title={s.title}
          subtitle={s.providerName}
        >
          {s.description && <p>{s.description}</p>}
        </CatalogCard>
      )}
    >
      {/* The search bar /stiri and /evenimente have, with its search alone: services have no
          dates to filter by. */}
      <ListingFilterPanel
        ariaLabel={t('servicesSearchLabel')}
        filters={{ q: query }}
        canReset={query.length > 0}
        results=""
        period={false}
        searchLabel={t('servicesSearchLabel')}
        searchPlaceholder={t('servicesSearchPlaceholder')}
        variant="plain"
        onFilter={({ q }) => {
          const next = new URLSearchParams(params);
          if (q?.trim()) next.set('q', q.trim());
          else next.delete('q');
          setParams(next, { preventScrollReset: true });
        }}
        onReset={() => setParams(new URLSearchParams(), { preventScrollReset: true })}
      />
    </CatalogSection>
  );
}
